import i18n from "i18n";
const NAMESPACES = ["server_errors", "enterprise_server_errors"];
const LOOKUP_OPTIONS = { keySeparator: false, nsSeparator: false };
const translateCode = (code, params) => {
  const ns = NAMESPACES.find((namespace) => i18n.exists(code, { ns: namespace, ...LOOKUP_OPTIONS }));
  return ns ? i18n.t(code, { ...params, ns, ...LOOKUP_OPTIONS }) : void 0;
};
const bodyOf = (error) => {
  var _a;
  const body = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.body;
  return body && typeof body === "object" ? body : void 0;
};
const translateApiError = (error) => {
  const body = bodyOf(error);
  const code = body == null ? void 0 : body.code;
  if (typeof code !== "string") {
    return void 0;
  }
  const params = (body == null ? void 0 : body.params) && typeof body.params === "object" ? body.params : {};
  return translateCode(code, params);
};
const translateDetail = (detail) => {
  var _a;
  return typeof detail.code === "string" ? translateCode(detail.code, (_a = detail.params) != null ? _a : {}) : void 0;
};
export const translateValidationResult = (validation) => {
  const details = validation == null ? void 0 : validation.error_details;
  if (!(validation == null ? void 0 : validation.errors) || !details) {
    return validation;
  }
  const errors = Object.fromEntries(
    Object.entries(validation.errors).map(([field, messages]) => [
      field,
      messages.map((message) => {
        var _a, _b;
        const detail = (_a = details[field]) == null ? void 0 : _a.find((candidate) => candidate.message === message);
        return (_b = detail && translateDetail(detail)) != null ? _b : message;
      })
    ])
  );
  return { ...validation, errors };
};
export default translateApiError;
